import { addDays, format, getDay, nextMonday } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

import { computePriceMetrics, DATE_FORMAT, VariantDataArgs } from './types';
import { NEW_YORK_TIMEZONE } from './usePriceMarketReactionData';

export const getEarningsData = ({
  days,
  priceByDay,
  reportingDateET,
  isReportingPreMarket,
  prevCloseHistoryData,
  isLoading,
}: VariantDataArgs) => {
  // Previous day for pre-market insights
  const theoreticalFromDate = isReportingPreMarket
    ? addDays(reportingDateET, -1)
    : reportingDateET;
  const theoreticalFromDateStr = format(theoreticalFromDate, DATE_FORMAT);
  const directIndex = days.indexOf(theoreticalFromDateStr);
  // Fallback on previous day with data to handle weekends or holidays
  const fromIndex =
    directIndex >= 0
      ? directIndex
      : Math.max(
          days.findLastIndex(day => day <= theoreticalFromDateStr),
          0
        );

  const fromPriceData = (priceByDay[days[fromIndex]] ?? []).filter(point => {
    const zonedTime = toZonedTime(new Date(point.time), NEW_YORK_TIMEZONE);
    const hours = zonedTime.getHours();
    const minutes = zonedTime.getMinutes();
    return hours > 9 || (hours === 9 && minutes >= 30);
  });

  const toDay = days[fromIndex + 1];
  const toPriceData = toDay
    ? priceByDay[toDay].filter(point => {
        const zonedTime = toZonedTime(new Date(point.time), NEW_YORK_TIMEZONE);
        const hours = zonedTime.getHours();
        const minutes = zonedTime.getMinutes();
        return hours < 16 || (hours === 16 && minutes === 0);
      })
    : [];

  const fromDateForFallback = new Date(`${days[fromIndex]}T16:00:00`);
  const dayOfWeek = getDay(fromDateForFallback);
  const fallbackToDate = [0, 5, 6].includes(dayOfWeek)
    ? nextMonday(fromDateForFallback)
    : addDays(fromDateForFallback, 1);

  const priceData = [...fromPriceData, ...toPriceData];

  return {
    priceData,
    fromDateEST: new Date(`${days[fromIndex]}T09:30:00`),
    toDateEST: toDay ? new Date(`${toDay}T16:00:00`) : fallbackToDate,
    ...computePriceMetrics(priceData, prevCloseHistoryData),
    isLoading,
  };
};
